import { render, staticRenderFns } from "./ResourceTypesListEditingPage.vue?vue&type=template&id=478affc3&scoped=true&"
import script from "./ResourceTypesListEditingPage.vue?vue&type=script&lang=ts&"
export * from "./ResourceTypesListEditingPage.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceTypesListEditingPage.vue?vue&type=style&index=0&id=478affc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478affc3",
  null
  
)

export default component.exports